// extracted by mini-css-extract-plugin
export default {"controls":"_7BPHZmRIYhgAi9iivUKsYs","button":"_3whw8mOhztuDgXAAzxLo4R","disclaimer":"_5bEZbVUeIlVgAtzQ3BFFtT","content":"_3qG44foTdKdmKX7LBjbUZz"};